import { render, staticRenderFns } from "./ForgetPasswd.vue?vue&type=template&id=25d52022&scoped=true"
import script from "./ForgetPasswd.vue?vue&type=script&lang=js"
export * from "./ForgetPasswd.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswd.vue?vue&type=style&index=0&id=25d52022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d52022",
  null
  
)

export default component.exports